import React, 
      { useState , 
        useEffect,}       from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import TextField         from '@mui/material/TextField'
import Dialog            from '@mui/material/Dialog'
import DialogActions     from '@mui/material/DialogActions'
import DialogContent     from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle       from '@mui/material/DialogTitle'
import Button            from '@mui/material/Button'
import axios             from 'axios'
import store             from '../../store'
import '../../App.css'
import '../../style.css'
import {ICHI_NEN_KANJI,
        NI_NEN_KANJI,
        SAN_NEN_KANJI,
        YON_NEN_KANJI,
        GO_NEN_KANJI,
        ROKU_NEN_KANJI,} from "../ObjectData"
import {baseId,
        MUSIC_GAME,
        MUSIC_POKEMON_KANJI_BATLE,
        MUSIC_POKEMON_KANJI_VICTORY,
        IMG_MONSTER_BALL,
        IMG_SUPER_BALL,
        IMG_HYPER_BALL,
        IMG_MASTER_BALL,
        IMG_MAIN_CHAR_BG,
        IMG_BALL_ON,
        IMG_BALL_NONE,} from '../Contants'
import ZukanSavedDialog from "./Dialog"

function KanjiGame() {
  const [pokemonImage   , setPokemonImage   ] = useState()      // ポケモン画像表示
  const [pokemonname    , setPokemonName    ] = useState("")    // ポケモンの名前
  const [pokemonhight   , setPokemonHight   ] = useState()      // ポケモンの高さ
  const [pokemonweight  , setPokemonWeight  ] = useState()      // ポケモンの重さ
  const [pokemontext    , setPokemonText    ] = useState()      // ポケモンの説明文
  const [pokemonid      , setPokemonID      ] = useState()      // ポケモンのNo
  const [pokemongenus   , setPokemonGenus   ] = useState()      // ポケモンの分類
  const [pokemonLevel   , setPokemonLevel   ] = useState()      // ポケモンのレベル
  const [pokemonHP      , setPokemonHP      ] = useState()      // ポケモンのHP
  const [getkanji       , setGetKanji       ] = useState()      // 漢字をセット
  const [inputvalue     , setInputValue     ] = useState()      // 画数の入力値
  const [resultWord     , setResultWord     ] = useState()      // 正解 or 不正解の判定
  const [fontColor      , setFontColor      ] = useState()      // フォントカラー
  const [count          , setCount          ] = useState(1)     // 問題数
  const [dialogopen     , setDialogOpen     ] = useState(false) // ダイアログ表示の状態管理
  const [correctCount   , setCorrectCount   ] = useState(0)     // 正解の数
  const [getPokemonList , setGetPokemonList ] = useState([])    // 正解したポケモンの画像を格納する配列
  const [resultStroke   , setResultStroke   ] = useState()      // 画数の答え
  var gakunenSelect = 0
  var useEffectCount = 0  // useEffectのカウンタ
  var BuffNum        = [] // 取得した漢字

  // 音楽が流れる
  const [gameMusic]       = useState(new Audio(MUSIC_GAME))
  const [battleAudio]     = useState(new Audio(MUSIC_POKEMON_KANJI_BATLE))
  const [pokemonVictory ] = useState(new Audio(MUSIC_POKEMON_KANJI_VICTORY))

  // 図鑑保存ダイアログ用
  const [savedDialogOpen, setSavedDialogOpen] = useState(false)
  const [savedDialogMessage, setSavedDialogMessage] = useState("図鑑に登録しました。")

  // 初期値に戻す
  const initialize = () => {
    // setShowRadioGroup(true)
    setPokemonImage("")
    setPokemonName("")
    setCount(1)
    setFontColor("")
    setResultWord("")
    setInputValue("")
    setCorrectCount(0)
    setGetPokemonList([])
  }

  // 初回起動時の処理
  useEffect(() => {
    console.log("★" , useEffectCount)
    useEffectCount = useEffectCount+1
    
    // useEffectが2回呼び出される？ため、２回目のみ処理を起動する
    if(useEffectCount === 1){
      console.log("選択中のゲームモード=>",store.getState().GameModeSelect)
      // 選択した学年情報の取得
      getGakunenInfo()
      // 1秒待機する
      setTimeout(() => {
        // 音楽を再生
        startPokemonBatlePlay()

        // ポケモンを呼び出す
        fetchPokemonImages()

        // 漢字情報を取得
        GetKanji()
      }, 1000) // 500ミリ秒 = 0.5秒待機
    }
  }, [])

  // バトル音楽を再生
  const startPokemonBatlePlay = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    battleAudio.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      battleAudio.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // 勝利音楽を再生
  const startPokemonVictoryPlay = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    pokemonVictory.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      pokemonVictory.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // 音楽をすべて停止
  const AllMusicPause = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
  }

  // ポケモンAPIを呼び出す
  const fetchPokemonImages = async () => {
    // ポケモンAPIを呼び出す
    // No.151までを取得
    const randomNumber = Math.floor(Math.random() * 898) + 1
    // ポケモンAPIを呼び出す
    const response = await axios.get("https://pokeapi.co/api/v2/pokemon/" + randomNumber)
    const speciesUrl = response.data.species.url
    const speciesResponse = await axios.get(speciesUrl)

    // ポケモンの画像を取得
    setPokemonImage(response.data.sprites.front_default)

    // ポケモンの名前を取得
    const japaneseName = speciesResponse.data.names.find(name => name.language.name === "ja").name
    setPokemonName(japaneseName)
    console.log(pokemonname)

    // ポケモンのHPを設定
    setPokemonHP(Math.floor(Math.random() * 100) + 1)

    // ポケモンのレベルを設定
    setPokemonLevel(Math.floor(Math.random() * 100) + 1)

    // 高さを取得
    setPokemonHight(response.data.height)

    // 重さを取得
    setPokemonWeight(response.data.weight)

    // Noを取得
    setPokemonID(response.data.id)
    // const speciesUrl = response.data.species.url
    // const speciesResponse = await axios.get(speciesUrl)

    // 分類（genera：ja-Hrktが無いことがある）
    const genera = speciesResponse?.data?.genera || [];
    const genusObj =
        genera.find(v => v?.language?.name === "ja-Hrkt") ||
        genera.find(v => v?.language?.name === "ja") ||
        genera.find(v => v?.language?.name === "en")
    setPokemonGenus(genusObj?.genus ?? "")

    // 説明文
    const flavorTextEntries = speciesResponse?.data?.flavor_text_entries || [];

    const pickFlavor = (lang, version) =>
      flavorTextEntries.find(
        (v) => v?.language?.name === lang && v?.version?.name === version
      )?.flavor_text;

    const cleanedText =
      pickFlavor("ja-Hrkt", "sword") ||
      pickFlavor("ja", "sword") ||
      pickFlavor("ja-Hrkt", "y") ||
      pickFlavor("ja", "y") ||
      pickFlavor("ja-Hrkt", "sun") ||
      pickFlavor("ja", "sun") ||
      pickFlavor("ja-Hrkt", "ultra-sun") ||
      pickFlavor("ja", "ultra-sun") ||
      "ポケモンのデータがありませんでした。";

    setPokemonText(cleanedText);
  }

  // 選択した学年情報の取得
  const getGakunenInfo = () => {
    switch(store.getState().GakunenSelect){
      case "1":
        gakunenSelect = ICHI_NEN_KANJI.length
        break
      case "2":
        gakunenSelect = NI_NEN_KANJI.length
        break
      case "3":
        gakunenSelect = SAN_NEN_KANJI.length
        break
      case "4":
        gakunenSelect = YON_NEN_KANJI.length
        break
      case "5":
        gakunenSelect = GO_NEN_KANJI.length
        break
      case "6":
        gakunenSelect = ROKU_NEN_KANJI.length
        break
      default:
        break
    }
  }

  // 漢字情報の取得
  const GetKanji = async () => {
    // ICHI_NEN_KANJIの配列の長さ分だけ乱数を取得
    var GetRandomNum = Math.floor(Math.random() * (gakunenSelect)) + 1
    console.log("gakunenSelect:" ,gakunenSelect)
    console.log("GetRandomNum:" ,GetRandomNum)
    console.log("store.getState().GakunenSelect:",store.getState().GakunenSelect)
    switch(store.getState().GakunenSelect){
      case "1":
        BuffNum = ICHI_NEN_KANJI.filter(item => (item.Num == GetRandomNum))
        console.log("1" , BuffNum)
        break
      case "2":
        BuffNum = NI_NEN_KANJI.filter(item => (item.Num == GetRandomNum))
        console.log("2")
        break
      case "3":
        BuffNum = SAN_NEN_KANJI.filter(item => (item.Num == GetRandomNum))
        break
      case "4":
        BuffNum = YON_NEN_KANJI.filter(item => (item.Num == GetRandomNum))
        break
      case "5":
        BuffNum = GO_NEN_KANJI.filter(item => (item.Num == GetRandomNum))
        break
      case "6":
        BuffNum = ROKU_NEN_KANJI.filter(item => (item.Num == GetRandomNum))
        break
      default:
        console.log("それ以外！")
        break
    }
    console.log("※" , BuffNum[0].Kanji)
    setGetKanji(BuffNum[0].Kanji)

    console.log("getKanji => ",BuffNum[0].Kanji)
    const url = 'https://kanjialive-api.p.rapidapi.com/api/public/kanji/' + BuffNum[0].Kanji
    const options = {
      method: 'GET',
      headers: {
        'X-RapidAPI-Key': '70e202a520mshb60567aec6f7fb3p1c946bjsn435d63484a08',
        'X-RapidAPI-Host': 'kanjialive-api.p.rapidapi.com'
      }
    };

    try {
      const response = await fetch(url, options);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const result = await response.json()
      setResultStroke(result.kanji.strokes.count)
      console.log("画数" , result.kanji.strokes.count)
    } catch (error) {
      console.error('Error:', error.message)
    }
  }

  // テキストボックスの内容
  const handleChange = (event) => {
    // 入力された値が数字でない場合は削除します
    const inputValue = event.target.value.replace(/[^0-9]/g, '')
    setInputValue(inputValue)
  }

  // 答えが入力された時の処理
  const handleKeyPressResult = (event) => {
    if (event.key === 'Enter') {
      console.log("入力値 => ",event.target.value)
      
      if (event.target.value == resultStroke) {
        console.log("正解")
        setResultWord("せいかい！GET！！")  // 結果のメッセージ
        setFontColor("red")                // フォントカラー設定

        // 図鑑用のポケモンデータを作成
        const newPokemon = {
          id     : pokemonid  , // 漢字ゲームなので null にしておく
          name   : pokemonname, // ポケモン名
          image  : pokemonImage,// 画像
          height : pokemonhight  ,
          weight : pokemonweight ,
          genus  : pokemongenus  ,
          text   : pokemontext   ,
          mode   : 'kokugo',                             // どのモードでゲットしたか
          grade  : store.getState().GakunenSelect,       // 学年
          kanji  : getkanji,                             // 出題された漢字
        }

        // // 配列に加える
        setGetPokemonList(prevList => {
          const newList = [...prevList, newPokemon];
          console.log("getPokemonList : ", newList, newList.length)
          return newList
        })

        setCorrectCount(correctCount + 1)  // 正解数を増加
        setPokemonImage(IMG_MONSTER_BALL)          // 画像をモンスターボールに変更
      } else {
        console.log("不正解")
        setFontColor("blue")              // フォントカラー設定
        setResultWord("にげられた。。。")  // 結果メッセージ
      }

      // カウントアップ
      setCount(count+1)
      console.log("count => " , count)
      setInputValue("")
      // 10問で終了、終了後は処置期画面へ
      if(count == 10){
        // 2秒待機する
        setTimeout(() => {
          console.log("終了")

          // ダイアログを表示する
          handleDialogOpen(true)

        }, 1000); // 2000ミリ秒 = 2秒待機
      }else{
        // 選択した学年情報の取得
        getGakunenInfo()

        // ポケモンを再取得
        fetchPokemonImages()

        // 漢字情報を取得
        GetKanji()

        // 2秒待機する
        setTimeout(() => {
          setResultWord("")
        }, 2000) // 2000ミリ秒 = 2秒待機
      }
    }
  }

  // ダイアログを開く
  const handleDialogOpen = () => {
    setDialogOpen(true)
    // 勝利音楽を再生
    startPokemonVictoryPlay()
  }

  // ダイアログを閉じる
  // もう一度ゲームをやる
  const handleGameReturn = () => {
    setDialogOpen(false)
    // 初期状態に戻す
    initialize(true)

    // バトル音楽を再生
    startPokemonBatlePlay()

    // ポケモンを呼び出す
    fetchPokemonImages()

    // 漢字情報を取得
    GetKanji()
  }

  // ダイアログを閉じる
  // リフレッシュする
  const handleGameReflesh = () => {
    setDialogOpen(false)
    // 初期状態に戻す
    initialize(true)

    window.location.reload() // 画面をリフレッシュする
  }

    // ローカルストレージに保存
  const handleSaveLocalStrage = () => {

    // 初期状態でローカルストレージから既存のデータを取得
    let existingPokemonData
    try {
      existingPokemonData = JSON.parse(localStorage.getItem('pokemondata'))
      // データがnullの場合や配列でない場合、空の配列を設定
      if (!Array.isArray(existingPokemonData)) {
        existingPokemonData = []
      }
    } catch (error) {
      console.error("データ取得に失敗しました。：", error)
      existingPokemonData = []
    }

    // ポケモンリストを追加する処理
    for (var i = 0; i < getPokemonList.length; i++) {
      // 既存のデータに新しいデータを追加
      existingPokemonData.push(getPokemonList[i])
    }

    // 更新されたデータを一度だけローカルストレージに保存
    try {
      localStorage.setItem('pokemondata', JSON.stringify(existingPokemonData))
      // 保存完了ダイアログを表示
      setSavedDialogMessage("図鑑に登録しました。")
      setSavedDialogOpen(true)
    } catch (error) {
      console.error("Failed to save data to localStorage:", error)
      // 失敗時の表示
      setSavedDialogMessage("保存に失敗しました…")
      setSavedDialogOpen(true)
    }

    // 最終的なデータをコンソールに出力
    console.log(existingPokemonData)
  }

  return (
      <Box sx={{ m : 1 , p : 4}}>
        {/* ダイアログの表示領域 */}
        <ZukanSavedDialog
        open={savedDialogOpen}
        message={savedDialogMessage}
        onClose={() => setSavedDialogOpen(false)}
        />
        {/* 画面 */}
        <Paper sx={{ m: 1, p: 1 ,
                bgcolor      : '#f5f5dc'  ,
                borderRadius : "1px"      , 
                height       : "250px"    ,
                width        : '250px'    ,
                position     : 'absolute' , // 絶対位置指定
                top          : '20px'     , // 縦位置を50pxに指定
                left         : '40px'     , // 横位置を20pxに指定
        }}>

          {/* ダイアログ表示 */}
          <Dialog
            open={dialogopen}
            onClose={handleGameReturn}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
              <Grid container spacing={2}>
                <Grid item xs={1} align="right">
                  <img
                      src    = {IMG_MONSTER_BALL}
                      width  = "50px"
                      height = "50px"/>
                </Grid>
                <Grid item xs={10} align="center">
                  <Typography
                    sx={{
                    // 独自フォントに設定
                    fontFamily   : 'DotGothic16'   , // Kalamフォント
                    fontSize     : "25px"    , 
                    color        : '#000000' , // フォントの色を黒に設定
                    }}>うまく入力できたかな？
                  </Typography>
                </Grid>
                <Grid item xs={1} align="left">
                  <img
                    src    = {IMG_MONSTER_BALL}
                    width  = "50px"
                    height = "50px"/>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Grid container spacing={2}>
                  <Grid item xs={12} align="center">
                    <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "16px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      }}>正しく入力できたかず
                    </Typography>
                  </Grid>
                  <Grid item xs={12} align="center">
                    <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "27px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      }}>{correctCount} もん
                    </Typography>
                  </Grid>
                  <Grid item xs={12} align="center">
                  <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "16px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      }}>↓↓↓↓↓ゲットしたポケモン↓↓↓↓↓</Typography>
                  </Grid>
                  {/* ポケモン画像表示 */}
                  {getPokemonList.map((p , index) => (
                    <Grid item xs = {3} align="center">
                      <Button>
                        <img
                          key    = {index}
                          src    = {p.image}
                          width  = "130px"
                          />
                      </Button>
                      {/* ポケモンの名前 */}
                      {/* {pokemonnames[index]} */}
                    </Grid>
                  ))}
                </Grid>
              </DialogContentText>
            </DialogContent>
            {/* <DialogActions>
              <Button onClick={handleGameReflesh}>
                はじめのがめん
              </Button>
              <Button 
                onClick={handleGameReturn} 
                variant='contained'>
                もういちど
              </Button>
            </DialogActions> */}
            <DialogActions>
            <Grid container spacing={2}>
              <Grid item xs = {4} align="center">
                <Button onClick={handleGameReflesh}>
                  <img
                  src    = {IMG_SUPER_BALL}
                  width  = "50px"
                  height = "50px"/>
                </Button>
                <Typography
                  sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "16px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                  }}>はじめのがめん</Typography>
              </Grid>

              <Grid item xs = {4} align="center">
                <Button 
                  onClick={handleGameReturn} >
                  <img
                    src    = {IMG_HYPER_BALL}
                    width  = "50px"
                    height = "50px"/>
                </Button>
                <Typography
                  sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "16px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                  }}>もういちど</Typography>
              </Grid>

              <Grid item xs = {4} align="center">
                <Button 
                  onClick={handleSaveLocalStrage}>
                  <img
                    src    = {IMG_MASTER_BALL}
                    width  = "50px"
                    height = "50px"/>
                </Button>
                <Typography
                  sx={{
                  // 独自フォントに設定
                  fontFamily   : 'DotGothic16'   , // Kalamフォント
                  fontSize     : "16px"    , 
                  color        : '#000000' , // フォントの色を黒に設定
                  }}>ずかんにとうろくする</Typography>
              </Grid>
            </Grid>
            </DialogActions>
          </Dialog>

          {/* 相手側を表示 */}
          {/* ポケモンの名前 */}
          <Grid item xs={12} align="left">
            <Typography
                sx={{
                // 独自フォントに設定
                fontFamily   : 'DotGothic16' , // Kalamフォント
                fontSize     : "13px"        , // フォントサイズ
                color        : '#000000'     , // フォントの色を黒に設定
                paddingLeft  : '10px'        , // 左側に10pxのパディングを追加して右にずらす
                }}>{pokemonname}　Lv:{pokemonLevel}</Typography>
          </Grid>
          <Grid 
            item xs={12} 
            align="left"
            sx={{
              position     : 'absolute',
              top          : '25px',
              left         : '10px',
              width        : '50%',
              padding      : '0 5px',
              borderLeft   : '3px solid #000000', // 右から左に変更
              borderBottom : '3px solid #000000',
              borderRight  : 'none', // 左から右に変更
              borderTop    : 'none',
              borderRadius : '3px',
              '::before'   : {
                content      : '""',
                position     : 'absolute',
                bottom       : '-1px', // 下枠線と重ならないように調整
                right        : '0px',  // 左から右に変更
                width        : 0,
                height       : 0,
                borderStyle  : 'solid',
                borderWidth  : '10px 0 0 20px', // 直角三角形を反転
                borderColor  : 'transparent transparent transparent #000000', // 三角形の色を右に設定
              },
            }}>
            <Grid item xs={12} align="left">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center', // 縦方向の中央揃え
                }}>
                <Typography
                  sx={{
                    fontFamily   : 'DotGothic16', // フォント
                    fontSize     : '13px',        // フォントサイズ
                    color        : '#000000',     // フォントの色を黒に設定
                    
                  }}>
                    HP：
                </Typography>
                <div
                  style={{
                    width: '65%',
                    backgroundColor: '#e0e0e0',
                    borderRadius: '5px',
                    overflow: 'hidden',
                  }}>
                  <div
                    style={{
                      width           : `${pokemonHP}%`, // HPの割合（ここでは70%）
                      height          : '10px',          // HPバーの高さ
                      backgroundColor : '#000000',       // HPバーの色
                      borderRadius    : '5px 0 0 5px',   // 左端を角丸にする
                    }}>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>

          {/* ポケモン表示 */}
          <Grid 
            item xs={12} 
            align="right"
            style={{
              marginTop: '-20px',   // 上にずらす
            }}>
            <div 
              style={{
                width: '120px',
                height: '120px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: pokemonImage ? 'none' : 'none', // pokemonImageが空白の場合は枠線を表示しない
              }}>
              {pokemonImage && (
                <img
                  src={pokemonImage}
                  width="100px"
                  height="100px"
                  alt="Pokemon"
                  style={{
                    border: 'none', // 画像の枠線を削除
                  }}
                />
              )}
            </div>
          </Grid>

          {/* 自分側を表示 */}
          <Grid 
            item xs={12} 
            align="center"
            sx={{
              position     : 'absolute',
              top          : '150px',
              left         : '125px',
              width        : '50%',
              padding      : '0 5px',
              borderRight  : '3px solid #000000',
              borderBottom : '3px solid #000000',
              borderLeft   : 'none',
              borderTop    : 'none',
              borderRadius : '3px',
              '::before'   : {
                content      : '""',
                position     : 'absolute',
                bottom       : '-1px', // 下枠線と重ならないように調整
                left         : '0px',
                width        : 0,
                height       : 0,
                borderStyle  : 'solid',
                borderWidth  : '10px 20px 0 0', // 直角三角形を作成
                borderColor  : 'transparent #000000 transparent transparent', // 三角形の色を設定
              },}}>
            <Typography
              sx={{
                // 独自フォントに設定
                fontFamily   : 'DotGothic16', // フォント
                fontSize     : '14px',        // フォントサイズ
                color        : '#000000',     // フォントの色を黒に設定
              }}>
              <Grid 
                item xs={12} 
                align="center"
                sx={{
                  display: 'flex',
                  justifyContent: 'right', // 画像を中央揃え
                }}>
                {/* 中身のあるモンスターボールを表示 */}
                {[...Array(5)].map((_, index) => (
                  <img
                    key={index}
                    src={IMG_BALL_ON}
                    alt={`Ball On ${index + 1}`}
                    width="17px"
                    height="17px"
                  />))}
                  {/* 中身のないモンスターボールを表示 */}
                  <img
                    src={IMG_BALL_NONE}
                    width="17px"
                    height="17px"
                  />
              </Grid>
            </Typography>
          </Grid>
          {/* 主人公のバック画像表示 */}
          <Grid 
            item xs={12} 
            align="left"
            className="slide-in-animation" // CSSクラスを追加
            style={{
              position: 'relative', // アニメーションのために必要
              marginTop: '-50px', // 上にずらす
            }}>
              <img
                src={IMG_MAIN_CHAR_BG}
                width="100px"
                height="100px"
                alt="Main Character"
              />
          </Grid>

          {/* メッセージ欄表示 */}
          <Grid 
            item xs={12} 
            align="center"
            sx={{
              border       : '3px solid #000000', // 枠線の太さと色を設定
              borderRadius : '5px',      // 角丸の半径を設定
              padding      : '0 5px',    // 上下0px、左右20pxの余白を設定
              top          : '180px',    // 縦位置を指定
              left         : '5px',      // 横位置を指定
              position     : 'absolute', // 絶対位置指定
              width        : '96%',      // 外枠の幅を指定
              height       : '30%',      // 外枠の高さを指定
            }}>
            <Typography
              sx={{
                fontFamily : 'DotGothic16', // フォント
                fontSize   : "14px", 
                color      : '#000000',     // フォントの色を黒に設定
              }}
              tabIndex={0} // キーボードフォーカス可能にする
            >
              {/* resultWordの値によって表示する内容が変わる */}
              {resultWord ? (
                <span style={{ color: fontColor, fontSize: '14px' }}>{resultWord}</span>
              ) : (
                `${pokemonname}があらわれた！`
              )}
            </Typography>
            <Typography
              sx={{
                display    : 'flex',        // 子要素を横並びにする
                alignItems : 'baseline',    // 子要素をベースラインに合わせて配置
                fontFamily : 'DotGothic16', // フォント
                fontSize   : "30px", 
                color      : '#000000',     // フォントの色を黒に設定
                textAlign  : 'left',        // テキストを左寄せに設定
                width      : '100%',        // 幅を100%に設定して左寄せが反映されるようにする
                paddingLeft: '20px',        // テキストの左側に余白を追加
              }}
              tabIndex={0} // キーボードフォーカス可能にする
            >
              {getkanji} ⇒
              <TextField
                autoFocus
                variant   = "outlined"
                size      = "small"
                value     = {inputvalue}
                onChange  = {handleChange}
                onKeyDown = {handleKeyPressResult} // Enterキーを押したときのイベントハンドラ
                style     =
                  {{ width: '80px', height: '30px', marginLeft: '10px' }} // 高さを25pxに設定して調整
              />
              <span style={{ fontSize: '16px' }}>(画数)</span>
            </Typography>
          </Grid>
        </Paper>
        <Grid container spacing={2}>
            <Grid item xs={12} align="center"></Grid>
        </Grid>
    </Box>
  );
}

export default KanjiGame
